import { render } from "./ActiveUserChart.vue?vue&type=template&id=284f8ba4&ts=true"
import script from "./ActiveUserChart.vue?vue&type=script&lang=ts"
export * from "./ActiveUserChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__